import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2e48bd7a&scoped=true&"
var script = {}
import style0 from "./Footer.scoped.scss?vue&type=style&index=0&id=2e48bd7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e48bd7a",
  null
  
)

export default component.exports